// app/packages/platform-contract/src/signature/form-configuration.schema.ts
//
// FormConfiguration aggregate — read-only lookup that drives slot-roster
// resolution at dialog open (Stages 1 + 2). Mirrors design.md §6
// (doc-signature-stubs).
import { z } from 'zod';

export const FormConfigurationSignatureLookupSchema = z.object({
  formConfigurationSignatureId: z.string().guid(),
  signatureType: z.string().min(1).max(100),
  isRequiredForPending: z.boolean(),
  isRequiredForApproved: z.boolean(),
  isRequiredInOpenShift: z.boolean(),
  hideWithoutApprovalRights: z.boolean(),
  orderId: z.number().int().min(1).max(255),
  isActive: z.boolean(),
  allowEmployeeChange: z.boolean(),
  allowEmployeeChangeIfNotSelected: z.boolean(),
  employeeComboBoxId: z.string().guid().nullable(),
  defaultToCurrentUser: z.boolean(),
  defaultToSelectedEmployee: z.boolean(),
  /** intent.md deviation — defaulted (Topaz hardware out of scope). */
  signatureDeviceIdentifier: z.string().default('Primary Device'),
});

export const FormConfigurationCriteriaLookupSchema = z.object({
  formConfigurationCriteriaId: z.string().guid(),
  criteriaType: z.string().min(1).max(100),
  value: z.string().min(1).max(255),
  orderId: z.number().int().min(1).max(255),
});

export const FormConfigurationLookupSchema = z.object({
  formConfigurationId: z.string().guid(),
  formIdentifier: z.string().min(1).max(255),
  formSubIdentifier: z.string().max(255).nullable(),
  formDescription: z.string().max(1000),
  allowPendingStatus: z.boolean(),
  automaticallyPrint: z.boolean().nullable(),
  printCount: z.number().int().nullable(),
  printCountDigitallySigned: z.number().int(),
  enableBackground: z.boolean(),
  signatures: z.array(FormConfigurationSignatureLookupSchema),
  criteria: z.array(FormConfigurationCriteriaLookupSchema),
});

export type FormConfigurationSignatureLookup = z.infer<typeof FormConfigurationSignatureLookupSchema>;
export type FormConfigurationCriteriaLookup = z.infer<typeof FormConfigurationCriteriaLookupSchema>;
export type FormConfigurationLookup = z.infer<typeof FormConfigurationLookupSchema>;
